import { render, staticRenderFns } from "./PartnerUpdateVATID.vue?vue&type=template&id=30678dd4&scoped=true"
import script from "./PartnerUpdateVATID.vue?vue&type=script&lang=js"
export * from "./PartnerUpdateVATID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30678dd4",
  null
  
)

export default component.exports